import { Component, computed, inject, input, output } from "@angular/core";

import { AdaaHelper } from "../../../../core/utils/adaa-helper";
import { Language } from "../../../constants/enums";
import { RadioOption } from "../../../models/shared-model";
import { AppService } from "../../../services/app-service";

@Component({
  selector: "adaa-form-radio",
  imports: [],
  templateUrl: "./form-radio.html",
  styleUrl: "./form-radio.scss",
})
export class FormRadioComponent {
  private readonly _appService = inject(AppService);

  readonly setDefaultValue = input<unknown>(null);
  readonly options = input<RadioOption[]>([]);
  readonly controlName = input<string | null>(null);
  readonly controlId = input<string | null>(null);
  readonly styles = input<string>("");
  readonly label = input<string>("");

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly inputChanges = output<any>();

  readonly effectiveControlId = computed(() => this.controlId() ?? this.controlName());
  readonly direction = computed(() => (this._appService.language() === Language.Arabic ? "rtl" : "ltr"));

  readonly AdaaHelper = AdaaHelper;
}
